export default "__VITE_ASSET__Ddvk6ydo__"